function normalizeDraftNode(value, seen) {
  if (value === undefined) return null;
  if (value === null || typeof value !== 'object') {
    if (typeof value === 'number' && !Number.isFinite(value)) return String(value);
    return value;
  }
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value.toISOString();
  if (seen.has(value)) throw new TypeError('Draft state must not contain circular references.');
  seen.add(value);
  const normalized = Array.isArray(value)
    ? value.map(item => normalizeDraftNode(item, seen))
    : Object.fromEntries(Object.keys(value).sort().map(key => [key, normalizeDraftNode(value[key], seen)]));
  seen.delete(value);
  return normalized;
}

// Stable across object-key order. Arrays stay ordered because condition, band,
// module and layout order is part of the authored configuration.
export function normalizedDraftSignature(value) {
  return JSON.stringify(normalizeDraftNode(value, new WeakSet()));
}

export function draftsDiffer(current, baseline) {
  return normalizedDraftSignature(current) !== normalizedDraftSignature(baseline);
}
